<svg width="24px" height="24px" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 <polygon points="8.9167 8.2676 12.01 2 15.103 8.2676 22.02 9.2727 17.015 14.151 18.197 21.04 12.01 17.788 5.8235 21.04 7.005 14.151 2 9.2727" fill="#999" fill-rule="evenodd"/>
</svg>
